<div
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  class="flex items-center justify-center gap-1 rounded-3xl px-2 text-xs hover:cursor-pointer"
  [ngClass]="{
    'bg-primary-100 text-primary-600': limits() === null,
    'bg-warning-100 text-warning-600': limits() && limits().length > 0,
    'bg-success-100 text-success-600': limits() && limits().length === 0,
  }"
  [matTooltip]="limits() === null ? 'Нажміть, щоб розпочати пошук лімітів' : ''"
  (mouseover)="toggleTemplate(true)"
  (mouseout)="toggleTemplate(false)"
  (click)="openPrescriptionLimitsModal()"
>
  @if (limits() === null) {
    <mat-icon>gpp_maybe</mat-icon>
  }
  @if (limits() && limits().length > 0) {
    <mat-icon>gpp_maybe</mat-icon>
    <span>{{ "лімітована" }}</span>
  }
  @if (limits() && limits().length === 0) {
    <mat-icon>verified_user</mat-icon>
    <span>{{ "без обмежень" }}</span>
  }
  @if (loadingLimits()) {
    <shared-spin-loading [size]="16"></shared-spin-loading>
  }
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="limitCardIsOpen()"
>
  <mat-card>
    <mat-card-content class="flex flex-col gap-4">
      @for (limit of limits(); track limit.limitRuleName) {
        <div class="mb-4 flex items-center gap-2 last:mb-0">
          <div class="h-8 w-8 rounded-full bg-warning-50 p-1">
            <mat-icon class="text-warning-500">gpp_maybe</mat-icon>
          </div>
          <div class="text-neutral-300 paragraph-3">
            {{ setRuleMessage(limit) }}
            <span class="text-neutral-500 subheader-2">
              {{ limit.limitAmount }}
              @switch (limit.limitType) {
                @case (type.Quantity) {
                  послуг
                }
                @case (type.Price) {
                  грн
                }
              }
            </span>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</ng-template>
